/* eslint-disable class-methods-use-this */
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { type ISourceOptions, tsParticles } from '@tsparticles/engine';
import { loadFull } from 'tsparticles';

@customElement('umb-market-particles')
export class UmbMarketParticles extends LitElement {
  @property({ type: Object })
  options?: ISourceOptions = {
    particles: {
      move: {
        decay: 0.05,
        direction: 'top',
        enable: true,
        gravity: {
          enable: true,
        },
        outModes: {
          top: 'none',
          default: 'destroy',
        },
        speed: {
          min: 10,
          max: 50,
        },
      },
      number: {
        value: 100,
      },
      opacity: {
        value: 1,
      },
      rotate: {
        value: {
          min: 0,
          max: 360,
        },
        direction: 'random',
        animation: {
          enable: true,
          speed: 30,
        },
      },
      tilt: {
        direction: 'random',
        enable: true,
        value: {
          min: 0,
          max: 360,
        },
        animation: {
          enable: true,
          speed: 30,
        },
      },
      size: {
        value: {
          min: 0,
          max: 2,
        },
        animation: {
          enable: true,
          startValue: 'min',
          count: 1,
          speed: 16,
          sync: true,
        },
      },
      roll: {
        darken: {
          enable: true,
          value: 25,
        },
        enable: true,
        speed: {
          min: 5,
          max: 15,
        },
      },
      wobble: {
        distance: 30,
        enable: true,
        speed: {
          min: -7,
          max: 7,
        },
      },
      shape: {
        type: 'emoji',
        options: {
          emoji: {
            particles: {
              size: {
                value: 12,
              },
            },
            value: ['🦄', '⭐️', '🎉'],
          },
        },
      },
    },
  };

  async connectedCallback() {
    super.connectedCallback();
    await loadFull(tsParticles);

    this.addEventListener('confetti', this.#confettiTime);
  }

  disconnectedCallback(): void {
    this.removeEventListener('confetti', this.#confettiTime);
    super.disconnectedCallback();
  }

  #confettiTime() {
    if ((tsParticles.domItem(0)?.particles.count ?? 0) > 50) return;
    tsParticles.load({ id: 'particles', options: this.options });
  }

  render() {
    return html`<div id="particles">
      <canvas></canvas>
      <slot></slot>
    </div>`;
  }

  static styles = css`
    canvas {
      display: none;
    }
  `;
}
